var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"map",staticClass:"msu-map",attrs:{"aria-label":_vm.$t('Карта органов МСУ')}}),(_vm.items.length === 0)?_c('v-alert',{staticClass:"mt-4",attrs:{"type":"info","outlined":""}},[_vm._v(" "+_vm._s(_vm.$t('Для выбранных органов координаты пока не заполнены'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }